<template>
  <div>
    <div class="voucher-ios-box">
      <p class="voucher-ios-txt">
        구매 진행 시
        <a href="#" @click="openAgreement('service')">서비스이용약관</a>과
        <a href="#" @click="openAgreement('privacy')">개인정보 처리방침</a>을
        확인해주세요.
      </p>
      <p class="voucher-ios-txt">
        이용권 구매 후에 서비스 이용권한 확인이 안되신다면
        <button class="voucher-ios-btn" @click="clickRestore">
          구매내역 복원</button
        >을 통해 권한을 다시 불러올 수 있습니다. 그래도 확인이 안되신다면 결제
        내역을 다시 한번 확인해주세요.
      </p>
    </div>
    <div class="exclamation-list">
      <h3 class="exclamation-hd">서비스 이용 주의사항</h3>
      <ul>
        <li
          v-for="serviceCaution in CAUTIONS_FOR_SERVICE_IOS"
          :key="serviceCaution"
          v-html="getTextLinks(serviceCaution, CAUTIONS_FOR_IOS_LINK)"
        ></li>
      </ul>
    </div>
    <div class="exclamation-list">
      <h3 class="exclamation-hd">서비스 이용 권장사양</h3>
      <ul>
        <li
          v-for="recommendation in RECOMMENDATION_FOR_SERVICE_IOS"
          :key="recommendation"
          v-html="recommendation"
        ></li>
      </ul>
    </div>
    <div class="exclamation-list">
      <h3 class="exclamation-hd">이용권 구매 주의 사항</h3>
      <ul>
        <li
          v-for="caution in CAUTIONS_FOR_PURCHASE_IOS"
          :key="caution"
          v-html="getTextLinks(caution, linkObject)"
        ></li>
      </ul>
    </div>
    <div class="exclamation-list">
      <h3 class="exclamation-hd">App Store 결제 주의사항</h3>
      <ul>
        <li
          v-for="appStoreCaution in CAUTIONS_FOR_PURCHASE_APP_STORE_IOS"
          :key="appStoreCaution"
          v-html="appStoreCaution"
        ></li>
      </ul>
      <div class="button-area">
        <button @click="openAgreement('service')">서비스 이용약관</button>
        <button @click="openAgreement('privacy')">개인정보 처리방침</button>
      </div>
      <portal v-if="isOpenAgreement" to="agreement-popup">
        <div class="info-popup-background"></div>
        <div class="info-popup-wrapper">
          <div class="info-popup-header">
            <span v-if="type === 'service'">서비스 이용약관</span>
            <span v-if="type === 'privacy'">개인정보 처리방침</span>
            <button class="btn-modal-close" @click="closeAgreement">
              <img src="/img/common/btn-close-white.png" alt="팝업 닫기" />
            </button>
          </div>
          <div ref="agreement-body" class="agreement-body">
            <div v-if="termsData !== null" class="policy-wrap">
              <div class="policy-date">
                시행일자 {{ termsData.effectivedate }}
              </div>
              <div class="policy-desc" v-html="termsData.content"></div>
              <div class="policy-btn">
                <ul>
                  <li v-if="termsData.prevversion !== ''" class="pre-policy">
                    <a
                      href="#"
                      @click.prevent="
                        getAgreementVersion(termsData.prevversion)
                      "
                    >
                      <img src="/img/common/arrow-title-prev.png" alt="" />
                      <span>이전 약관 보기</span>
                    </a>
                  </li>
                  <li v-if="termsData.version !== 'last'" class="now-policy">
                    <a href="#" @click.prevent="getAgreementVersion('last')">
                      <span>현재 약관 보기</span>
                      <img src="/img/common/arrow-title-next.png" alt=""
                    /></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </portal>
    </div>
  </div>
</template>

<script>
  import { AgreementService } from '@/common/api/api.service'
  import { isApp } from '@/common/util/common'
  import { getTextLinks } from '@/common/util/string-manipulation/get-text-links'
  import {
    CAUTIONS_FOR_SERVICE_LINK,
    CAUTIONS_FOR_SERVICE_IOS,
    RECOMMENDATION_FOR_SERVICE_IOS,
    CAUTIONS_FOR_PURCHASE_IOS,
    CAUTIONS_FOR_SERVICE_LINK_APP,
    CAUTIONS_FOR_SERVICE_LINK_WEB,
    CAUTIONS_FOR_PURCHASE_APP_STORE_IOS,
  } from '@/components/lnb/voucher/voucher-text/const'

  export default {
    data() {
      return {
        isOpenAgreement: false,
        type: '',
        termsData: null,
        version: 'last',
        CAUTIONS_FOR_SERVICE_IOS,
        RECOMMENDATION_FOR_SERVICE_IOS,
        CAUTIONS_FOR_IOS_LINK: CAUTIONS_FOR_SERVICE_LINK,
        CAUTIONS_FOR_PURCHASE_IOS,
        CAUTIONS_FOR_SERVICE_LINK_APP,
        CAUTIONS_FOR_PURCHASE_APP_STORE_IOS,
      }
    },
    computed: {
      linkObject() {
        return isApp()
          ? CAUTIONS_FOR_SERVICE_LINK_APP
          : CAUTIONS_FOR_SERVICE_LINK_WEB
      },
    },
    methods: {
      getTextLinks,
      // 구매내역 복원하기
      clickRestore() {
        try {
          window.webkit.messageHandlers.clickRestore.postMessage('clickRestore')
        } catch (err) {
          console.log(err)
        }
      },
      openAgreement(type) {
        this.type = type
        this.getAgreementVersion(this.version)
        // this.isOpenAgreement = true
      },
      closeAgreement() {
        this.version = 'last'
        this.isOpenAgreement = false
      },
      getAgreementVersion(termVersion) {
        this.version = termVersion
        this.setAgreementData()
      },
      setAgreementData() {
        AgreementService.getTerms({
          type: this.type,
          version: this.version,
        }).then(({ data }) => {
          this.termsData = data
          this.isOpenAgreement = true
          this.$nextTick(() => {
            this.$refs['agreement-body'].scrollTo(0, 0)
          })
        })
      },
      getInquiryUrl() {
        return isApp()
          ? 'captvpooq://customer/qna/inquiry'
          : 'https://member.wavve.com/mobile/customer/qna/ask?device=mobile'
      },
    },
  }
</script>
<style scoped>
  .button-area {
    margin-top: 20px;
    font-size: 0;
  }
  .button-area button {
    display: inline-block;
    width: 47.5%;
    height: 32px;
    border: 1px #1351f9 solid;
    border-radius: 44px;
    background-color: #1351f9;
    font-size: 14px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
  }
  .button-area button + button {
    margin-left: 5%;
  }
  .info-popup-wrapper {
    display: table;
    position: fixed;
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5000;
    width: 90%;
    height: 66%;
    background-color: #252525;
  }
  .info-popup-background {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 4000;
  }
  .info-popup-header {
    position: relative;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    color: #fff;
    text-align: center;
  }
  .btn-modal-close {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
  }
  .btn-modal-close img {
    width: 100%;
  }
  /*.vue-friendly-iframe {*/
  /*  position: relative;*/
  /*  margin: 0 auto;*/
  /*  height: 70%;*/
  /*  width: 100%;*/
  /*}*/
  /*.vue-friendly-iframe iframe {*/
  /*  width: 100% !important;*/
  /*  height: 100% !important;*/
  /*}*/
  .agreement-body {
    position: relative;
    min-height: 56px;
    height: calc(100% - 80px);
    margin: 20px 0;
    overflow-y: scroll;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
    font-size: 14px;
    line-height: 18px;
    color: #a5a5a5;
    word-break: break-all;
  }
  .agreement-body::-webkit-scrollbar {
    display: none;
  }
  .policy-date {
    padding: 0 15px;
    height: 44px;
    line-height: 44px;
    font-size: 12px;
    color: #a5a5a5;
    border-bottom: 1px solid #2f2f2f;
  }
  .policy-desc {
    font-size: 13px;
    line-height: 22px;
    color: #a5a5a5;
    padding: 15px 15px 50px;
  }
  .policy-wrap {
    width: 100%;
    padding-bottom: 30px;
  }
  .policy-wrap::-webkit-scrollbar {
    display: none;
    background-color: transparent;
  }
  .policy-btn {
    padding-left: 10px;
  }
  .policy-btn a {
    display: block;
    width: 100%;
    height: 30px;
    padding: 0 12px;
    border-radius: 100px;
    border: 1px solid #d9d9d9;
    font-size: 0;
    line-height: 28px;
    text-align: center;
    color: #fff;
  }
  .policy-btn a img,
  .policy-btn a span {
    display: inline-block;
    font-size: 12px;
    vertical-align: middle;
  }
  .policy-btn a img {
    width: 12px;
    height: 12px;
  }
  .policy-btn a img + span,
  .policy-btn a span + img {
    margin-left: 3px;
  }
  .policy-btn ul::after {
    content: '';
    display: table;
    clear: both;
  }
  .policy-btn li {
    float: left;
    text-align: center;
  }
</style>
